import React, { Component } from 'react'
import PriorDaysConfigPageUI from './PriorDaysConfigPageUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class PriorDaysConfigPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            reminderList: [],
            loading: true, // Start with loading state
            error: null,
            isEditModalOpen: false,
            selectedReminder: null,
            updateSuccess: false
        }
    }

    componentDidMount() {
        this.fetchPriorDaysConfigs()
    }

    // Fetch all prior days configurations
    fetchPriorDaysConfigs = () => {
        this.setState({ loading: true, error: null })

        RestApiUtils.get(this.props.context, '/api/prePostDaysConfig/getAllPrePostDaysConfig',
            (data) => {
                if (!data.success) {
                    this.setState({ loading: false, error: data.errorList.length > 0 ? data.errorList[0].message : 'Failed to fetch configurations' })
                    return
                }
                const { success, errorList, prePostDaysConfigs } = data

                if (success === 'success' && prePostDaysConfigs) {
                    // Transform API data to component state format
                    const reminderList = prePostDaysConfigs.map((config, index) => {
                        return {
                            id: index + 1,
                            name: config.eventType,
                            dayOfMonth: config.dayOfMonth,
                            isPrior: config.isPrior,
                            updatedBy: config.updatedBy,
                            updatedAt: config.updatedAt
                        }
                    })
                    this.setState({
                        reminderList,
                        loading: false,
                        error: null
                    })
                } else {
                    this.setState({
                        loading: false,
                        error: errorList.length > 0 ? errorList[0].message : 'Failed to fetch configurations'
                    })
                }
            })
    }

    // Handle edit button click
    handleEditClick = (reminder) => {
        this.setState({
            isEditModalOpen: true,
            selectedReminder: { ...reminder }
        })
    }

    resetSuccess = () => {
        this.setState({ updateSuccess: false });
    };

    // Handle modal close
    handleModalClose = () => {
        this.setState({
            isEditModalOpen: false,
            selectedReminder: null
        })
    }

    // Handle day of month change
    handleDayOfMonthChange = (e) => {
        console.log(e.target)
        const { value } = e.target
        this.setState(prevState => ({
            selectedReminder: {
                ...prevState.selectedReminder,
                dayOfMonth: value
            }
        }))
    }

    // Handle update reminder
    handleUpdateReminder = () => {
        const { selectedReminder } = this.state

        if (!selectedReminder) {
            console.error('No reminder selected for update');
            return;
        }

        const { name, dayOfMonth, isPrior } = this.state.selectedReminder

        const data = {
            eventType: name,
            dayOfMonth: dayOfMonth,
            isPrior: isPrior
        }

        // Make the API call
        this.setState({ loading: true, error: null, updateSuccess: false })

        RestApiUtils.post(this.props.context, '/api/prePostDaysConfig/update', (data) => {
            if (!data.success) {
                this.setState({ loading: false, error: data.errorList.length > 0 ? data.errorList[0].message : 'Failed to update configuration', selectedReminder: null, isEditModalOpen: false })
                return
            }
            const { success, errorList } = data
            if (success === 'success') {
                this.setState({
                    isEditModalOpen: false,
                    selectedReminder: null,
                    updateSuccess: true
                })
                this.fetchPriorDaysConfigs()
            } else {
                this.setState({
                    loading: false,
                    error: errorList.length > 0 ? errorList[0].message : 'Failed to update configuration',
                    updateSuccess: false,
                    selectedReminder: null,
                    isEditModalOpen: false
                })
            }
        }, data)
    }

    render() {
        const {
            reminderList,
            loading,
            error,
            isEditModalOpen,
            selectedReminder,
            updateSuccess
        } = this.state

        return (
            <PriorDaysConfigPageUI
                context={this.props.context}
                reminderList={reminderList}
                loading={loading}
                error={error}
                isEditModalOpen={isEditModalOpen}
                selectedReminder={selectedReminder}
                updateSuccess={updateSuccess}
                resetSuccess={this.resetSuccess}
                onEditClick={this.handleEditClick}
                onModalClose={this.handleModalClose}
                onDayOfMonthChange={this.handleDayOfMonthChange}
                onUpdateReminder={this.handleUpdateReminder}
            />
        )
    }
}

export default PriorDaysConfigPageSF